module.exports = __webpack_public_path__ + "static/media/LookScreenIP.d04ca166.png";